import React from 'react';
import ModalMessage from '../../UI/organisms/ModalMessage';
import Signup from '../../Auth/Signup';
import { withTranslation } from 'next-i18next';
import { X } from 'lucide-react';
import { Card, CardHeader, CardTitle, CardContent } from '@lb-classroom/ui';

interface SignupModalContentProps {
  t: (key: string, options?: Record<string, unknown>) => string;
  message?: string;
  messageType?: string;
  hideModal: () => void;
  clearModalMessage: () => void;
}

const SignupModalContent = (props: SignupModalContentProps) => {
  const { t, message, messageType, hideModal, clearModalMessage } = props;
  return (
    <div className="max-w-lg mx-auto">
      <Card className="z-50">
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle>{t('title.signup')}</CardTitle>
          <button type="button" className="modal-close" onClick={hideModal}>
            <span className="sr-only">Close</span>
            <X className="h-5 w-5" aria-hidden="true" />
          </button>
        </CardHeader>
        <CardContent>
          <ModalMessage message={message} messageType={messageType} />
          <Signup inModal={true} clearModalMessage={clearModalMessage} />
        </CardContent>
      </Card>
    </div>
  );
};

export default withTranslation('common')(SignupModalContent);
